export const columnToBucket = {
  "link_to_ticket": "tickets",
  "link_to_generated_document": "compensations",
};
